<p-confirmDialog key="ssrebuild" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>
<p-confirmDialog key="ssrebuildconfirm" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>
<p-confirmDialog key="ssrebuilddoublecheck" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Search Options-->
<div class="SearchOptions">
	<h4 class="OptionHeader" style="grid-column: 1/3">Search for ScanStations</h4>

	<label>School:</label>
	<caass-schoolselector [ShowAll]="true" [Disabled]="IsLoading() == true"></caass-schoolselector>

	<label>Facility:</label>
	<p-dropdown
		style="margin-left: 5px"
		[disabled]="IsLoading() == true"
		[options]="lstFacility"
		[(ngModel)]="SelectedFacility"
		(ngModelChange)="onFacilityChange($event)"
		optionLabel="FacilityFullName"
		[filter]="true"
		filterBy="FacilityFullName"
		[showClear]="false"
		placeholder="Select a Facility"
	>
		<ng-template pTemplate="selectedItem">
			<div *ngIf="SelectedFacility">
				<div class="form-control NoBorder" style="text-align: left">{{ SelectedFacility.FacilityFullName }}</div>
			</div>
		</ng-template>
		<ng-template let-FacilityItem pTemplate="item">
			<div>
				<div class="form-control NoBorder" style="text-align: left">{{ FacilityItem.FacilityFullName }}</div>
			</div>
		</ng-template>
	</p-dropdown>
</div>

<!--Preview Table-->
<div class="PreviewDiv">
	<h4 class="OptionHeader">Select Stations to Rebuild</h4>

	<!--Table-->
	<div class="table-main-body">
		<p-table
			#mydt
			[value]="lstScanStation"
			[loading]="LoadingScanStation == true"
			[paginator]="true"
			[(rows)]="pagerows"
			[(first)]="pagefirst"
			[showCurrentPageReport]="true"
			[resizableColumns]="false"
			sortMode="multiple"
			styleClass="p-datatable-striped"
			selectionMode="multiple"
			[(selection)]="SelectedScanStations"
			dataKey="ScanStationID"
			(onRowSelect)="onRowSelect($event)"
			(onRowUnselect)="onRowUnselect($event)"
			currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
			[rowsPerPageOptions]="[5, 10, 25, 50]"
		>
			<!--Headers-->
			<ng-template pTemplate="header">
				<!--Filter or Select from Dropdown-->
				<tr>
					<th></th>

					<!--INSERT CUSTOM FILTERS HERE-->

					<!--ScanStation-->
					<th>
						<p-columnFilter type="text" field="ScanStation" matchMode="contains" [showMenu]="true"></p-columnFilter>
					</th>

					<!--FacilityFullName-->
					<th>
						<p-columnFilter field="FacilityFullName" matchMode="equals" [showMenu]="false">
							<ng-template pTemplate="filter" let-value let-filter="filterCallback">
								<p-dropdown
									#filterFacilityFullName
									[ngModel]="value"
									[options]="lstFacilityFullName"
									(onChange)="filter($event.value)"
									placeholder="Any"
									[showClear]="true"
								>
									<ng-template let-value pTemplate="item">
										<span>{{ value }}</span>
									</ng-template>
								</p-dropdown>
							</ng-template>
						</p-columnFilter>
					</th>

					<!--IsScanStationDesc-->
					<th>
						<p-columnFilter field="IsScanStationDesc" matchMode="equals" [showMenu]="false">
							<ng-template pTemplate="filter" let-value let-filter="filterCallback">
								<p-dropdown
									#filterIsScanStationDesc
									[ngModel]="value"
									[options]="lstIsScanStationDesc"
									(onChange)="filter($event.value)"
									placeholder="Any"
									[showClear]="true"
								>
									<ng-template let-value pTemplate="item">
										<span>{{ value }}</span>
									</ng-template>
								</p-dropdown>
							</ng-template>
						</p-columnFilter>
					</th>

					<!--IsMultiStationDesc-->
					<th>
						<p-columnFilter field="IsMultiStationDesc" matchMode="equals" [showMenu]="false">
							<ng-template pTemplate="filter" let-value let-filter="filterCallback">
								<p-dropdown
									#filterIsMultiStationDesc
									[ngModel]="value"
									[options]="lstIsMultiStationDesc"
									(onChange)="filter($event.value)"
									placeholder="Any"
									[showClear]="true"
								>
									<ng-template let-value pTemplate="item">
										<span>{{ value }}</span>
									</ng-template>
								</p-dropdown>
							</ng-template>
						</p-columnFilter>
					</th>

					<!--Version-->
					<th>
						<p-columnFilter field="Version" matchMode="equals" [showMenu]="false">
							<ng-template pTemplate="filter" let-value let-filter="filterCallback">
								<p-dropdown
									#filterVersion
									[ngModel]="value"
									[options]="lstVersion"
									(onChange)="filter($event.value)"
									placeholder="Any"
									[showClear]="true"
								>
									<ng-template let-value pTemplate="item">
										<span>{{ value }}</span>
									</ng-template>
								</p-dropdown>
							</ng-template>
						</p-columnFilter>
					</th>

					<!--OS-->
					<th>
						<p-columnFilter field="OS" matchMode="equals" [showMenu]="false">
							<ng-template pTemplate="filter" let-value let-filter="filterCallback">
								<p-dropdown
									#filterOS
									[ngModel]="value"
									[options]="lstOS"
									(onChange)="filter($event.value)"
									placeholder="Any"
									[showClear]="true"
								>
									<ng-template let-value pTemplate="item">
										<span>{{ value }}</span>
									</ng-template>
								</p-dropdown>
							</ng-template>
						</p-columnFilter>
					</th>

					<!--AlreadyRebuildingDesc-->
					<th>
						<p-columnFilter field="AlreadyRebuildingDesc" matchMode="equals" [showMenu]="false">
							<ng-template pTemplate="filter" let-value let-filter="filterCallback">
								<p-dropdown
									#filterAlreadyRebuildingDesc
									[ngModel]="value"
									[options]="lstAlreadyRebuildingDesc"
									(onChange)="filter($event.value)"
									placeholder="Any"
									[showClear]="true"
								>
									<ng-template let-value pTemplate="item">
										<span>{{ value }}</span>
									</ng-template>
								</p-dropdown>
							</ng-template>
						</p-columnFilter>
					</th>
				</tr>

				<!--Column Names-->
				<tr style="height: 4rem">
					<th>
						<p-tableHeaderCheckbox></p-tableHeaderCheckbox>
					</th>

					<!--INSERT CUSTOM COLUMNS HERE-->
					<th pSortableColumn="ScanStation">Station<p-sortIcon field="ScanStation"></p-sortIcon></th>
					<th pSortableColumn="FacilityFullName">Facility<p-sortIcon field="FacilityFullName"></p-sortIcon></th>
					<th pSortableColumn="IsScanStationDesc">Running ScanStation<p-sortIcon field="IsScanStationDesc"></p-sortIcon></th>
					<th pSortableColumn="IsMultiStationDesc">Running CAASS Visitors<p-sortIcon field="IsMultiStationDesc"></p-sortIcon></th>
					<th pSortableColumn="Version">Version<p-sortIcon field="Version"></p-sortIcon></th>
					<th pSortableColumn="OS">OS<p-sortIcon field="OS"></p-sortIcon></th>
					<th pSortableColumn="AlreadyRebuildingDesc">Already Rebuilding<p-sortIcon field="AlreadyRebuildingDesc"></p-sortIcon></th>
				</tr>
			</ng-template>

			<!--Data-->
			<ng-template pTemplate="body" let-ScanStation>
				<tr [pSelectableRow]="ScanStation">
					<td>
						<p-tableCheckbox
							[disabled]="IsLoading() == true || ScanStation.AlreadyRebuilding == true"
							[pSelectableRow]="ScanStation"
							[value]="ScanStation"
						></p-tableCheckbox>
					</td>

					<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
						{{ ScanStation.ScanStation }}
					</td>

					<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
						{{ ScanStation.FacilityFullName }}
					</td>

					<td
						style="font-weight: bold; text-overflow: ellipsis; word-break: break-word"
						[style.color]="ScanStation.IsScanStation == true ? 'Black' : 'Red'"
					>
						{{ ScanStation.IsScanStationDesc }}
					</td>

					<td
						style="font-weight: bold; text-overflow: ellipsis; word-break: break-word"
						[style.color]="ScanStation.IsMultiStation == true ? 'Black' : 'Red'"
					>
						{{ ScanStation.IsMultiStationDesc }}
					</td>

					<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
						{{ ScanStation.Version }}
					</td>

					<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
						{{ ScanStation.OS }}
					</td>

					<td
						style="font-weight: bold; text-overflow: ellipsis; word-break: break-word"
						[style.color]="ScanStation.AlreadyRebuilding == true ? 'Red' : 'Black'"
					>
						{{ ScanStation.AlreadyRebuildingDesc }}
					</td>
				</tr>
			</ng-template>
		</p-table>
	</div>
</div>

<!--Update-->
<div class="Buttons">
	<button [disabled]="IsLoading() == true" class="btn btn-primary" (click)="onRefresh()">Refresh</button>
	<button [disabled]="IsLoading() == true" class="btn btn-success" style="margin-left: 5px" (click)="onUpdate()">Rebuild</button>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">{{ errorMessage }}</div>
</div>
